import React, { useCallback, useState } from "react";
import TreeItem from "@material-ui/lab/TreeItem";
import TreeView from "@material-ui/lab/TreeView";
import { OpenInNewRounded } from "@material-ui/icons";

import type { FC, ChangeEvent } from "react";
import AddBoxOutlinedIcon from "../../../../../icons/OpenTree";
import RemoveOutlinedIcon from "../../../../../icons/CloseTree";
import { Hierarchy } from "../../../../common";

import { useStyles, useParentStyles, useItemStyles } from "./FavouriteItemsTree.styles";
import { useFavouriteItemsHierarchy } from "./useFavouriteItemsHierarchy";
import type { IFavouriteItemsTreeProps, IHierarchyItem } from "./FavouriteItemsTree.types";
import { FAVOURITE_ITEMS_GROUPS } from "./FavouriteItemsTree.constants";
import { FavouriteItemType } from "../../../types";

export const FavouriteItemsTree: FC<IFavouriteItemsTreeProps> = (props) => {
  const { value, onChange, items } = props;

  const classes = useStyles();
  const classesParent = useParentStyles();
  const classesItem = useItemStyles();

  const hierarchies = useFavouriteItemsHierarchy(items);

  const [expanded, setExpanded] = useState<string[]>(FAVOURITE_ITEMS_GROUPS.map((g) => g.id));

  const handleSelect = useCallback(
    (e: ChangeEvent<{}>, nodeId: string) => {
      const targetHierarchy = Hierarchy.flat(hierarchies).find((h) => h.id === nodeId);
      if (targetHierarchy !== undefined && !targetHierarchy.children?.length) {
        onChange?.(Number(targetHierarchy.origin.id));
      }
    },
    [onChange, hierarchies]
  );

  const handleExpand = useCallback(
    (e: ChangeEvent<{}>, nodeIds: string[]) => {
      setExpanded(nodeIds);
    },
    [setExpanded]
  );
  const handleFavoriteNavigation = (hierarchyItem: Hierarchy<string, IHierarchyItem>) => (event: React.MouseEvent<Element, MouseEvent>) => {
    event.stopPropagation();
    const favouriteItem = items.find((f) => f.id === Number(hierarchyItem.id));

    let url: string;
    switch (favouriteItem?.type) {
      case FavouriteItemType.Map:
        url = `/maps?favourite`;
        break;
      case FavouriteItemType.Slide:
        url = `/slides/${favouriteItem.mark.reportId}?favourite`;
        break;
      case FavouriteItemType.BulkExport:
        url = `/bulk-export?favourite=${favouriteItem.id}`;
        break;
      case FavouriteItemType.SavedBulkExport:
        url = `/bulk-export?savedFavourite=${favouriteItem.id}`;
        break;
      default:
        url = "/favourites";
    }

    window.open(url, "_blank");
  };

  return (
    <TreeView
      className={classes.treeView}
      defaultCollapseIcon={<RemoveOutlinedIcon />}
      defaultExpandIcon={<AddBoxOutlinedIcon />}
      expanded={expanded}
      selected={String(value)}
      onNodeSelect={handleSelect}
      onNodeToggle={handleExpand}
    >
      {hierarchies.map((hierarchy) => (
        <div key={hierarchy.id} className={classes.treeGroup}>
          <TreeItem nodeId={hierarchy.id} label={`${hierarchy.name} (${hierarchy.children.length})`} classes={classesParent}>
            {hierarchy.children.map((c) => (
              <TreeItem
                key={c.name}
                nodeId={c.id}
                label={c.name}
                classes={classesItem}
                endIcon={<OpenInNewRounded />}
                onIconClick={handleFavoriteNavigation(c)}
              />
            ))}
          </TreeItem>
        </div>
      ))}
    </TreeView>
  );
};
